import React from "react"
import PropTypes from "prop-types"

const FormError = ({ error = "" }) => {
  if (error) {
    return (
      <ul className="text-red-700">
        <li key={error}>{error}</li>
      </ul>
    )
  }
  return ""
}

FormError.propTypes = {
  error: PropTypes.string,
}

export default FormError
